export enum UserTypeEnum {
  Admin = 'admin',
  User = 'user',
}

export interface User {
  _id: string
  id?: string
  name: string
  email: string
  avatar: string | null
  predictions: Prediction[]
  type: UserTypeEnum
  roomRole?: string
}

export interface Prediction {
  _id: string
  winner: string | null
  predictedScore: string
  predictedScorePoint?: number
  predictedWinnerPoint?: number
  matchId: string
  userId: string
  roomId: string
}
